import { ChangeDetectorRef, Component, Input, ViewChild, ViewChildren } from '@angular/core';
import { Point } from '@angular/cdk/drag-drop';
import { MatTooltip } from '@angular/material/tooltip';
import { ContentCenterCharCommon, DashboardReportModel } from '@shared/models/dashboard-reports';
import { PieChartCommons } from '@shared/util-pie-chart/pieChartCommons';

interface PieChartAngleInfo {
  startAngle: number;
  angle: number;
}

interface PieChartPortion {
  angles: PieChartAngleInfo[];
  color: string;
  value: number;
  label: string;
  showLabel: boolean;
  labelAngle: number;
  disableTooltip: boolean;
}

export interface PieChartElement {
  label: string;
  color: string;
  value: number;
}

@Component({
  selector: 'mojo-pie-char-average',
  templateUrl: './pie-char-average.component.html',
  styleUrls: ['./pie-char-average.component.scss'],
})
export class PieCharAverageComponent {
  pieChartElements: PieChartElement[];
  pieCharAverage: DashboardReportModel;
  contentCenter: ContentCenterCharCommon;
  @ViewChild('donutChartElement') donutChartElement;

  public titleChar: string;
  pieChartPortionsAverage: Array<PieChartElement> = [];
  pieChartPortionAverageResponse: PieChartPortion[] = [];

  @Input() showAverages = true;
  @Input() set titleInput(title: string) {
    this.titleChar = title;
  }

  @Input() set elementsPieChar(val: DashboardReportModel) {
    this.pieCharAverage = val;

    this.buildDataToSendComponent(this.pieCharAverage);
    this.buildDatToAverageTable(this.pieCharAverage);

    this.contentCenter = {
      titleCenter: 'Total',
      total: this.pieCharAverage.totalApplicants,
      pieChartElements: this.pieChartElements,
    };
  }

  pieChartPortions: PieChartPortion[] = [];

  hoveredPortion: PieChartPortion;

  buildDatToAverageTable(pieCharAverage: DashboardReportModel) {
    let i = 0;
    this.pieCharAverage.data = pieCharAverage.data.map((item) => {
      const percentage = (item.average * 100) / this.pieCharAverage?.totalAverageApplicants;
      const totalPercentage = (item.value * 100) / this.pieCharAverage?.totalApplicants;

      if (item.label !== 'Applicants' && item.label !== 'Submission')
        return {
          ...item,
          color:
            i < PieChartCommons.colors.length
              ? PieChartCommons.colors[i++]
              : PieChartCommons.getRandomColor(),
          percentage: parseFloat(percentage + '').toFixed(2),
          totalPercentage: parseFloat(totalPercentage + '').toFixed(2),
        };

      return {
        ...item,
        color: PieChartCommons.getRandomColor(),
      };
    });
  }

  buildDataToSendComponent(val: DashboardReportModel) {
    let i = 0;
    this.pieChartElements = val.data
      .map((item) => {
        if (item.label !== 'Applicants' && item.label !== 'Submission') {
          return {
            label: item.label,
            color:
              i < PieChartCommons.colors.length
                ? PieChartCommons.colors[i++]
                : PieChartCommons.getRandomColor(),
            value: item.value,
          };
        }
      })
      .filter((item) => item !== undefined);
  }
}
